// extracted by mini-css-extract-plugin
export default {"btn":"WhatsAppFloat_btn__hm2oI","icon":"WhatsAppFloat_icon__qIjIm","pulse":"WhatsAppFloat_pulse__OIDzP","waPulse":"WhatsAppFloat_waPulse__c0zwW"};